import {RememberItems} from './merkliste/rememberItems';
import {TooltipLayer} from './merkliste/tooltipLayer';
import {UserRegistrationDialog} from './merkliste/userRegistrationDialog';

export class Merkliste {
    constructor(viewRoot: HTMLElement) {
        new RememberItems(viewRoot);
        new UserRegistrationDialog();
        new TooltipLayer();
    }
}
// wird benoetigt um in views die klasse zu laden
if (typeof window !== 'undefined') {
    (window as any)['Merkliste'] = Merkliste;
}
